import { render, staticRenderFns } from "./UnitsRow.vue?vue&type=template&id=19c558fc&scoped=true&"
import script from "./UnitsRow.vue?vue&type=script&lang=js&"
export * from "./UnitsRow.vue?vue&type=script&lang=js&"
import style0 from "./UnitsRow.vue?vue&type=style&index=0&id=19c558fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c558fc",
  null
  
)

component.options.__file = "UnitsRow.vue"
export default component.exports